import { isEmpty } from '~/modules';

export const fillStringIfEmpty = (text?: string, fillWith = '-'): string => {
  if (isEmpty(text)) return fillWith;
  return text as string;
};
